import { useState, createContext } from "react";

export const SelectedFiltersContext = createContext({
});

export const SelectedFiltersProvider = ({children}) => {

    const [filterSession, setFilterSession] = useState('all')


    const value = { filterSession, setFilterSession };

    return (
        <SelectedFiltersContext.Provider value={value}> {children} </SelectedFiltersContext.Provider>
    )
}